import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import {
  CloseOutlined,
  DownOutlined,
  LockOutlined,
  MailOutlined,
} from "@ant-design/icons";
import { Dropdown, Flex, Grid, Tag, Typography } from "antd";
import type { MenuItemType, ItemType } from "antd/es/menu/interface";

import { useAlerts } from "@contexts/Alerts";

import Button from "@components/Button";
import useAuth from "@hooks/useAuth";

import { Badge, Submenu } from "./styles";

export const UserDropdown = () => {
  const navigate = useNavigate();
  const { name, user, onLogout } = useAuth();
  const { alerts: notifications } = useAlerts();
  const screens = Grid.useBreakpoint();

  // const hasImportantNotifications = notifications.some(
  //   (n) => !!n.important && n.read === false,
  // );

  const resetPassword = useCallback(() => {
    navigate("/nova-senha");
  }, [navigate]);

  const items = useMemo<ItemType[]>(() => {
    const label: MenuItemType["label"] = (
      <Flex
        style={{ cursor: "pointer", color: "white", padding: "0 10px" }}
        gap={26}
      >
        <Flex vertical style={{ color: "inherit" }}>
          <Typography.Text
            aria-description={` Olá, ${name}!`}
            strong
            style={{ color: "inherit" }}
          >
            Olá, {name}!
          </Typography.Text>
          {user?.corbanName && (
            <Typography.Text
              aria-description={`Você está logado no ${user.corbanName}`}
              style={{ color: "inherit" }}
            >
              Você está logado no <b>{user.corbanName}</b>
            </Typography.Text>
          )}
        </Flex>

        <DownOutlined />
      </Flex>
    );

    const subMenuChildren: ItemType[] = [
      {
        key: "changePassword",
        type: "item",
        icon: <LockOutlined />,
        onClick: resetPassword,
        label: "Alterar Senha",
      },
    ];

    return [
      {
        key: "subMenu",
        label,
        type: "submenu",
        popupOffset: [0, 0],
        children: subMenuChildren,
      },
    ] satisfies ItemType[];
  }, [name, resetPassword, user?.corbanName]);

  return (
    <Flex
      flex={1}
      justify={screens.xs ? "flex-end" : "space-between"}
      align="center"
      gap={8}
    >
      <Flex align="center" gap={8}>
        <Dropdown
          menu={{
            items: items[0]?.type === "submenu" ? items[0]?.children : [],
          }}
          dropdownRender={(node) => <Submenu>{node}</Submenu>}
        >
          {items[0]?.type === "submenu" && items[0].label}
        </Dropdown>

        {user?.crcpInfo?.status === "deactivated" && (
          <Tag style={{ backgroundColor: "#FF4D4F", color: "white" }}>
            {!screens.md ? <CloseOutlined /> : "Digitação bloqueada"}
          </Tag>
        )}
      </Flex>

      <Flex gap={12} align="center">
        {/* <Popover
          defaultOpen={hasImportantNotifications}
          content={
            hasImportantNotifications && (
              <span>Você possui notificações importantes!</span>
            )
          }
          placement="topRight"
          arrow
        > */}
        <Badge
          count={(() => {
            if (!notifications.length) return 0;

            return notifications.reduce(
              (acc, n) => (n.important || !n.read ? acc + 1 : acc),
              0,
            );
          })()}
          color={(() => {
            if (notifications.some((n) => n.type === "error")) return "red";
            if (notifications.some((n) => n.type === "warning"))
              return "orange";
            return undefined;
          })()}
          offset={[0, 2]}
        >
          <Button
            type="primary"
            style={{
              boxShadow: "none",
            }}
            onClick={() => navigate("/notificacoes")}
            icon={<MailOutlined />}
          />
        </Badge>
        {/* </Popover> */}
        {!screens.xs && (
          <Button
            onClick={() => onLogout()}
            type="primary"
            style={{
              boxShadow: "none",
            }}
          >
            Sair
          </Button>
        )}
      </Flex>
    </Flex>
  );
};
